export default (state = {}) => state;
